




































import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import IInvestedStandardListPanel from "@/general/components/pages/parts/GrantCriteriaDetails/IInvestedStandardListPanel.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

import { getTypeLabel } from "@/common/assets/js/utils/types";
import LocalStorage from "@/general/utils/storage";
import { mapState } from "vuex";

@Component({
  components: {
    IconInvestedRounded,
    IInvestedStandardListPanel
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class IInvestedStandardList extends Vue {
  @Prop({ type: Array, default: [], required: true })
  investedStandardDetail!: any[];

  unit = commons.unit;

  storeColorCode: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get investedStandardDetailItem() {
    const {
      id,
      name,
      points,
      text,
      created_at,
      kind,
      grant_criteria_icon_id: icon_type
    } = this.investedStandardDetail[0];

    return {
      id,
      name,
      text,
      created_at: this.$dayjs
        .utc(created_at)
        .locale("ja")
        .format("YYYY/MM/DD"),
      points: `${points.toLocaleString()}${this.unit.point}`,
      kind: getTypeLabel(kind, true),
      icon_type
    };
  }

  get investedStandardHeadingArray() {
    return [
      {
        indexKey: "id",
        heading: "付与基準ID"
      },
      {
        indexKey: "points",
        heading: "ポイント数"
      },
      {
        indexKey: "name",
        heading: "付与基準名"
      },
      {
        indexKey: "text",
        heading: "摘要"
      },
      {
        indexKey: "icon_type",
        heading: "アイコン",
        iconComponent: true
      },
      {
        indexKey: "created_at",
        heading: "作成日"
      },
      {
        indexKey: "kind",
        heading: "ポイント種別"
      }
    ];
  }
}
